document.addEventListener('DOMContentLoaded', () => {
  const sectionPresentation = document.querySelector('.pres');
  const sectionGammes = document.querySelector('.gammes');
  const sectionEngagement = document.querySelector('.engagement-marque');
  const sectionArticles = document.querySelector('.articles');

  gsap.registerPlugin(ScrollTrigger);

  //Section Presentation
  gsap.from(sectionPresentation.querySelector('.pres__content'), {
    y: 150,
    opacity: 0,
    duration: 1,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: sectionPresentation,
      start: 'top center',
      end: 'bottom center',
    },
  });

  gsap.from(sectionPresentation.querySelector('.pattern__left'), {
    x: -150,
    opacity: 0,
    duration: 1,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: sectionPresentation,
      start: 'top center',
      end: 'bottom center',
    },
  });

  //Section Gammes
  gsap.from(
    sectionGammes.querySelectorAll('.gammes__left > h2, .gammes__navigation'),
    {
      x: -150,
      opacity: 0,
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: sectionGammes,
        start: 'top center',
        end: 'bottom center',
      },
    }
  );

  gsap.from(sectionGammes.querySelectorAll('.swiper-slide'), {
    y: 150,
    opacity: 0,
    duration: 1,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: sectionGammes,
      start: 'top center',
      end: 'bottom center',
    },
  });

  //Section Engagement
  gsap.from(sectionEngagement.querySelector('.engagement__content'), {
    y: 150,
    opacity: 0,
    duration: 1,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: sectionEngagement,
      start: 'top center',
      end: 'bottom center',
    },
  });
});

window.addEventListener('scroll', function() {
  console.log('scroll on single marque page');
  const header = document.querySelector('.header');
  if (window.scrollY > 50) {
    console.log('header--hidden');
    header.classList.add('header--hidden');
  } else {
    console.log('header--hidden removed');
    header.classList.remove('header--hidden');
  }
});

// Fonction pour détecter Safari
function isSafari() {
  const ua = navigator.userAgent;
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  return isSafari;
}

// Ajouter une classe spécifique pour Safari
if (isSafari()) {
  console.log('Safari détecté');
  document.documentElement.classList.add('safari');
} else {
  console.log('Safari non détecté');
}

document.addEventListener('DOMContentLoaded', function() {
  const swiperWrapper = document.querySelector('.swiper-wrapper');
  const slides = swiperWrapper.querySelectorAll('.swiper-slide');
  const slideCount = slides.length;

  if (slideCount >= 4) {
    swiperWrapper.classList.add('swiper-wrapper--4-items');
  } else if (slideCount === 3) {
    swiperWrapper.classList.add('swiper-wrapper--3-items');
  } else if (slideCount === 2) {
    swiperWrapper.classList.add('swiper-wrapper--2-items');
  } else if (slideCount === 1) {
    swiperWrapper.classList.add('swiper-wrapper--1-item');
  }
});